export const browser = require("bowser").getParser(window.navigator.userAgent);

const supportedOperatingSystems = ['macos', 'windows', 'ios', 'chrome os', 'android'];

export default {
  ...browser.getResult(),
  isMobilePlatform: isMobilePlatform(),
  hasCompatibleOS: hasCompatibleOS(),
  getBrowserForSession: getBrowserForSession,
};

function getBrowserForSession() {
  return {
    name: browser.getBrowserName(),
    version: browser.getBrowserVersion(),
    os: browser.getOSName(),
  };
}

function isMobilePlatform() {
  return browser.getPlatformType().toLowerCase() === 'mobile';
}

function hasCompatibleOS() {
  return supportedOperatingSystems.includes(browser.getOSName().toLowerCase());
}
